import React from 'react'
import DashboardHeader from '../../components/Shop/Layout/DashboardHeader'
import DashboardSideBar from '../../components/Shop/Layout/DashboardSideBar'
import AllProducts from "../../components/Shop/AllProducts";

const ShopAllProducts = () => {
  return (
    <div className="dashboard-page-wrapper">
      <DashboardHeader />
      <div className="dashboard-flex-wrapper">
        <div className="w-[80px] 800px:w-[330px] dashboard-sidebar">
          <DashboardSideBar active={3} />
        </div>
        <div className="dashboard-main-content flex-1">
          <AllProducts />
        </div>
      </div>
    </div>
  )
}

export default ShopAllProducts